import React from "react";

const LoaderSpinner = () => {
  return (
    <div className="loadingio-spinner-spinner-nq4q5u6dq7r">
      <div className="ldio-x2uulkbinbj">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <style jsx>{`
        @keyframes ldio-x2uulkbinbj {
          0% {
            opacity: 1;
          }
          100% {
            opacity: 0;
          }
        }
        .ldio-x2uulkbinbj div {
          left: 78.49px;
          top: 48.43px;
          position: absolute;
          animation: ldio-x2uulkbinbj linear 1s infinite;
          background: #1355ff;
          width: 10.02px;
          height: 20.04px;
          border-radius: 5.01px / 10.02px;
          transform-origin: 5.01px 35.07px;
        }
        .ldio-x2uulkbinbj div:nth-child(1) {
          transform: rotate(0deg);
          animation-delay: -0.875s;
          background: #1355ff;
        }
        .ldio-x2uulkbinbj div:nth-child(2) {
          transform: rotate(45deg);
          animation-delay: -0.75s;
          background: #1355ff;
        }
        .ldio-x2uulkbinbj div:nth-child(3) {
          transform: rotate(90deg);
          animation-delay: -0.625s;
          background: #1355ff;
        }
        .ldio-x2uulkbinbj div:nth-child(4) {
          transform: rotate(135deg);
          animation-delay: -0.5s;
          background: #1355ff;
        }
        .ldio-x2uulkbinbj div:nth-child(5) {
          transform: rotate(180deg);
          animation-delay: -0.375s;
          background: #1355ff;
        }
        .ldio-x2uulkbinbj div:nth-child(6) {
          transform: rotate(225deg);
          animation-delay: -0.25s;
          background: #1355ff;
        }
        .ldio-x2uulkbinbj div:nth-child(7) {
          transform: rotate(270deg);
          animation-delay: -0.125s;
          background: #1355ff;
        }
        .ldio-x2uulkbinbj div:nth-child(8) {
          transform: rotate(315deg);
          animation-delay: 0s;
          background: #1355ff;
        }
        .loadingio-spinner-spinner-nq4q5u6dq7r {
          width: 167px;
          height: 167px;
          display: inline-block;
          overflow: hidden;
          background: transparent;
        }
        .ldio-x2uulkbinbj {
          width: 100%;
          height: 100%;
          position: relative;
          transform: translateZ(0) scale(1);
          backface-visibility: hidden;
          transform-origin: 0 0; /* see note above */
        }
        .ldio-x2uulkbinbj div {
          box-sizing: content-box;
        }
      `}</style>
    </div>
  );
};

export default LoaderSpinner;
